import { render, staticRenderFns } from "./StatQueuePage.vue?vue&type=template&id=4c5c65aa&scoped=true"
import script from "./StatQueuePage.vue?vue&type=script&lang=js"
export * from "./StatQueuePage.vue?vue&type=script&lang=js"
import style0 from "./StatQueuePage.vue?vue&type=style&index=0&id=4c5c65aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c65aa",
  null
  
)

export default component.exports